import React, { useState, useContext, useRef } from "react";
import { useHistory, useLocation } from "react-router";
import { DRIVE_SVG, DRIVE_BUTTON_SVG, CLOSE_SVG } from "../assets/index";
import { Button } from "./buttons";
import { useDrop } from "react-dnd";
import Popup from "./Popup";
import { DriveContext } from "..";
import { BPMSoundsGeneric } from "../generic";
import { errorToString } from "bpm-client-api";
import * as toastr from 'toastr';
import { translations } from "../translations";
var Sidebar = function (props) {
    var _a = useState(''), userInput = _a[0], setUserInput = _a[1];
    var _b = useState(false), enterDrive = _b[0], setEnterDrive = _b[1];
    var history = useHistory();
    var location = useLocation();
    var selected = location.pathname;
    var drives = useContext(DriveContext);
    var userInputBlank = function (userInput) {
        return userInput.trim().length < 1;
    };
    var addDriveInput = useRef(null);
    //^ RENDER NAV ITEMS
    var renderNavItems = function (navItemCluster) {
        return React.createElement(React.Fragment, null, navItemCluster.items.map(function (navItem) {
            return (React.createElement("li", { className: navItem.path && "item-container " + (selected.startsWith(navItem.path) ? 'selected' : ''), onClick: function (e) {
                    if (navItem.path && props.sidebarExpanded) {
                        history.push(navItem.path);
                    }
                    document.documentElement.scrollTop = 0;
                }, key: navItem.path },
                React.createElement("img", { className: "icon", src: navItem.iconImg, alt: navItem.altText }),
                React.createElement("span", { className: "text" }, navItem.text)));
        }));
    };
    //^ RENDER DRIVES OR COLLECTIONS
    var renderDrives = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(React.Fragment, null,
                BPMSoundsGeneric.get().driveManager.sortDrives(drives).map(function (drive) {
                    return React.createElement(DiveItem, { key: drive.id, drive: drive, selected: selected, history: history, onNavigateToDrive: props.onNavigateToDrive });
                }),
                React.createElement("div", { className: "drive-container " + (enterDrive ? 'enter-drive' : '') },
                    React.createElement("img", { className: "icon", src: DRIVE_BUTTON_SVG, alt: "Drive SVG" }),
                    React.createElement("li", { className: "item-container add-drive" },
                        React.createElement("div", { className: "buttons-container", style: !enterDrive ? { justifyContent: 'flex-start' } : {} },
                            React.createElement("span", { className: "text add-drive", onClick: function () {
                                    setUserInput('');
                                    if (enterDrive)
                                        setEnterDrive(false);
                                    else {
                                        setEnterDrive(true);
                                        setTimeout(function () {
                                            if (addDriveInput.current) {
                                                addDriveInput.current.focus();
                                            }
                                        }, 100);
                                    }
                                } }, !enterDrive ? "Add New " + translations.Drive : 'Cancel'),
                            React.createElement("div", { style: !enterDrive ? { display: 'none' } : {} },
                                React.createElement(Button, { className: "Add-btn", buttonText: 'Add', onClick: function () {
                                        if (userInputBlank(userInput))
                                            return;
                                        BPMSoundsGeneric.get().driveManager.createDrive(userInput);
                                        setUserInput('');
                                        setEnterDrive(false);
                                    }, textColor: '#fff' }))),
                        React.createElement("div", { className: "add-drive-popup " + (enterDrive ? '' : 'hidden') },
                            React.createElement("img", { className: "close", src: CLOSE_SVG, onClick: function () { return setEnterDrive(false); }, alt: "close" }),
                            React.createElement("input", { ref: addDriveInput, className: "search-bar", name: "input", type: "text", value: userInput, onChange: function (e) { return setUserInput(e.target.value); }, onKeyUp: function (e) {
                                    if (e.keyCode === 13) {
                                        if (userInputBlank(userInput))
                                            return;
                                        BPMSoundsGeneric.get().driveManager.createDrive(userInput);
                                        setEnterDrive(false);
                                    }
                                }, placeholder: "Enter " + translations.Drive + " name" }))))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "Sidebar container collapse-sidebar " + (!props.sidebarExpanded ? 'closed-sidebar' : 'open-sidebar push-main-content'), onClick: function (e) { return !props.sidebarExpanded ? props.setSidebarExpanded(true) : null; } },
            React.createElement("nav", { className: 'no-scrollbar' },
                React.createElement("ul", null, props.navItems.map(function (navItemCluster) {
                    return (React.createElement("div", { className: navItemCluster.category_name === "My Library" ? "my-library" : '', key: navItemCluster.category_name },
                        React.createElement("div", { className: "list-section-header", id: navItemCluster.id }, navItemCluster.category_name),
                        navItemCluster.category_name != translations.Drives
                            ? renderNavItems(navItemCluster)
                            : renderDrives()));
                }))))));
};
function DiveItem(_a) {
    var drive = _a.drive, selected = _a.selected, history = _a.history, onNavigateToDrive = _a.onNavigateToDrive;
    var _b = useDrop({
        accept: 'Sound',
        collect: function (monitor) { return ({
            isOver: monitor.isOver()
        }); },
        drop: function (_a) {
            var sound = _a.sound;
            if (Array.isArray(sound)) {
                Promise.all(sound.map(function (sound) {
                    BPMSoundsGeneric.get().driveManager.addSoundToDrive(sound, drive, true);
                })).then(function () {
                    toastr.success(translations.Sounds + " were successfully added to " + drive.name);
                }).catch(function (err) { return errorToString(err); });
            }
            else
                BPMSoundsGeneric.get().driveManager.addSoundToDrive(sound, drive);
        }
    }), isOver = _b[0].isOver, dropRef = _b[1];
    return (React.createElement("li", { ref: dropRef, className: "item-container drive " + (selected === "/drive/" + drive.id ? 'selected' : '') + " " + (isOver ? 'drop' : ''), key: drive.id, onClick: function () {
            onNavigateToDrive(drive);
        } },
        React.createElement("img", { className: "icon hidden", src: DRIVE_SVG, alt: "Drive SVG" }),
        React.createElement("span", { className: "text" }, drive.name),
        React.createElement("img", { className: "deleteDrive", src: CLOSE_SVG, alt: "delete", onClick: function () {
                return Popup.removeDrive(drive.name).then(function (action) {
                    if (action === 'ok') {
                        BPMSoundsGeneric.get().driveManager.deleteDrive(drive.id);
                        history.push('/');
                    }
                });
            } })));
}
export default Sidebar;
//# sourceMappingURL=Sidebar.js.map